import type {
  IProblemRecord,
  ISection,
  ISubnavItem,
  ITableBlock,
  ITableColumn,
  ITableUI,
} from "../../../shared/ui/data-table/model/data-table-contract";

export type {
  IProblemRecord,
  ISection,
  ISubnavItem,
  ITableBlock,
  ITableColumn,
  ITableUI,
};

export const getMedications = (store: {
  medications: { data: IProblemRecord | null };
}) => store.medications.data;
